import { NewFilter } from '@/types/NewFilter';

export const filters: NewFilter[] = [
	{
		key: 'pole',
		name: 'Polo',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'management',
		name: 'Gerência',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'coordination',
		name: 'Coordenação',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'workStation',
		name: 'Local de Trabalho',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'employee',
		name: 'Colaborador',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'generalInformationJobTitle',
		name: 'Função',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'requirementType',
		name: 'Tipo de Requisito',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'requirementClass',
		name: 'Classe',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'requirement',
		name: 'Requisito',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'status',
		name: 'Status',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'situation',
		name: 'Situação do requisito',
		isMulti: true,
		isDisabled: () => false,
	},
];
